import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import {
  Ch_generateSickLeaveDocumentInput,
  useChGenerateSickLeaveDocumentMutation as useChGenerateSickLeaveDocumentMutationType,
} from "@/modules/patients/detail/sick-leave-certificate/ch/services/__generated__/useChGenerateSickLeaveDocumentMutation.graphql"
import { usePatientParam } from "@/modules/patients/hooks/usePatientParam"

const generateSickLeaveDocumentMutation = graphql`
  mutation useChGenerateSickLeaveDocumentMutation($input: Ch_generateSickLeaveDocumentInput!) {
    ch_generateSickLeaveDocument(input: $input) {
      ch_SickLeave {
        id
        fileId
        ...chSickLeaveFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useChGenerateSickLeaveDocumentMutationType>, "variables"> & {
  params: Pick<Ch_generateSickLeaveDocumentInput, "id" | "progressNoteIds">
}

const useChGenerateSickLeaveDocumentMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChGenerateSickLeaveDocumentMutationType>(
    generateSickLeaveDocumentMutation,
    params,
  )
  const patientById = usePatientParam()

  const commitHandler = useCallback(
    (config: Config) => {
      commit({
        variables: {
          input: {
            patientId: patientById,
            id: config.params.id,
            progressNoteIds: config.params.progressNoteIds,
          },
        },
        ...config,
      })
    },
    [commit, patientById],
  )

  return [commitHandler, isFlight] as const
}

export { useChGenerateSickLeaveDocumentMutation }
